import React, { useState, useEffect } from "react";
import { LayoutEdicion, Edicion as EdicionContainer } from "../../containers";
import secureLocalStorage from "react-secure-storage";

export default function Editions({ slug }) {
  const [jugada, setJugada] = useState([]);
  let playId = window.location.pathname.replace("/app/editions/", "");
  const user = secureLocalStorage.getItem("user");

  useEffect(() => {
    setJugada(user?.plays[playId]);
  }, [user]);

  return (
    <LayoutEdicion>
      <EdicionContainer jugada={jugada} playId={playId} />
    </LayoutEdicion>
  );
}

export async function getServerSideProps({ res, params }) {
  const { slug } = params;
  return { props: { slug } };
}
